/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
/* eslint-disable react/display-name */
import { useState, Fragment, useRef, forwardRef } from "react";
import { Grid, SpeedDialAction } from "@material-ui/core";
import KsopHeaderInformation from "../ksopHeaderInformation/KsopHeaderInformation";
import KsopPersonalInformation from "../ksopPersonalInformation/KsopPersonalInformation";
import KsopBeneficiaryName from "../ksopBeneficiaryName/KsopBeneficiaryName";
import KsopNameChange from "../ksopNameChange/KsopNameChange";
import KsopPartcipantSignature from "../ksopPartcipantSignature/KsopPartcipantSignature";
import KsopBeneficiaryDesignation from "../ksopBeneficiaryDesignation/KsopBeneficiaryDesignation";

import "./ksopFormPrint.css";

const KsopFormPrint = forwardRef(({ primaryBeneficiary, contingentBeneficiary, enrollments }, ref) => {
	const { employee, KSOP_option, contingent_beneficiery, primary_beneficiery } = enrollments;

	if (!employee && !KSOP_option && !contingent_beneficiery && !primary_beneficiery) return <></>;
	return (
		<div className="ksop-container" ref={ref}>
			<div className="ksop-header-information" id="ksop-header-information">
				<KsopHeaderInformation isPrintable={true} />
			</div>
			<div className="ksop-personal-information" id="ksop-personal-information">
				<KsopPersonalInformation isPrintable={true} employeeDetails={employee} />
			</div>
			<div className="ksop-beneficiary-designation">
				<KsopBeneficiaryDesignation isPrintable={true} KSOP_option_props={KSOP_option} />
			</div>
			<div className="ksop-beneficiary-name" id="ksop-beneficiary-name">
				<KsopBeneficiaryName
					primaryBeneficiary={primary_beneficiery}
					contingentBeneficiary={contingent_beneficiery}
					isPrintable={true}
				/>
			</div>
			{/* <div className="ksop-name-change" id="ksop-name-change">
				<KsopNameChange isPrintable={true} />
			</div> */}
			<div className="ksop-participant-signature" id="ksop-participant-signature">
				<KsopPartcipantSignature isPrintable={true} />
			</div>
			<div className="buttom-flex font-size-12">
				<p>GP 24488-26</p>
				<div>
					<p style={{ textAlign: "center" }}>Please retain a copy for your records</p>
					<p>
						<b>THIS FORM MUST BE RETURNED TO THE BENEFITS DEPARTMENT</b>
					</p>
				</div>
				<p>05/2008</p>
			</div>
		</div>
	);
});

export default KsopFormPrint;
